<template>
  <section class="home-pain-container">
    <h2 class="home-title">설문 응답을 수집할 때마다 겪는 어려움들</h2>

    <div class="pain-grid">
      <div class="pain-card" v-for="(item, idx) in painList" :key="idx">
        <span class="pain-label">{{ item.label }}</span>
        <p class="pain-text">{{ item.text }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomePain',

  data() {
    return {
      painList: [
        { label: '대학생', text: '내일까지 응답 100개가 필요한데, 어떻게 다 모으지' },
        { label: '대학원생', text: '카톡방, 에타, 인스타에 링크 홍보하기 번거로운데' },
        { label: '스타트업', text: '응답자에게 기프티콘 보내기 귀찮은데, 언제 다 하지' }
      ]
    }
  }
}
</script>

<style scoped>
.home-pain-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
}

.home-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.pain-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.pain-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-6);
  background-color: var(--bg-sunken);
  border-radius: var(--radius-lg);
  text-align: left;
}

.pain-label {
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}

.pain-text {
  margin: 0;
  font-size: 17px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-heading);
  line-height: 1.5;
}

@media (max-width: 560px) {
  .home-title {
    font-size: 24px;
  }

  .pain-grid {
    grid-template-columns: 1fr;
  }
}
</style>
